export var durationSecond = 1000;
export var durationMinute = durationSecond * 60;
export var durationHour = durationMinute * 60;
export var durationDay = durationHour * 24;
export var durationWeek = durationDay * 7;
export var durationMonth = durationDay * 30;
export var durationYear = durationDay * 365;
